import { Array, Object, Optional, Number, Static, String, Record } from '@sinclair/typebox';

import { UnionEnum } from '../../../utils/unionEnum';
import { BoundFlight, UpsellTableTabs } from '../../flightOffers';
import { FareRules } from '../../sas-domain';

export const TravelPassFlightOffersRequest = Object({
  origin: String(),
  destination: String(),
  outDate: Optional(String()),
  inDate: Optional(String()),
  cid: String(),
  officeId: String(),
  routes: Array(Array(String())),
  commercialFareFamily: String(),
  adt: Number(),
  productCode: UnionEnum(['TPU', 'TMP', 'TPC']),
});
export type TravelPassFlightOffersRequest = Static<typeof TravelPassFlightOffersRequest>;

export const TravelPassFlightOffersQuery = Object({
  origin: String(),
  destination: String(),
  outDate: Optional(String()),
  inDate: Optional(String()),
  cid: String(),
  officeId: String(),
  commercialFareFamily: String(),
  adt: Number(),
  currency: String(),
});
export type TravelPassFlightOffersQuery = Static<typeof TravelPassFlightOffersQuery>;

export const TravelPassFlightOffersError = Object({
  errors: Array(
    Object({
      errorCode: String(),
      errorMessage: String(),
    })
  ),
});
export type TravelPassFlightOffersError = Static<typeof TravelPassFlightOffersError>;

export const TravelPassFlightOffersResponse = Object({
  type: String(),
  bookingFlow: String(),
  offerId: String(),
  currency: Object({ code: String() }),
  pricingType: String(),
  regionName: String(),
  outboundFlights: Optional(Array(BoundFlight)),
  inboundFlights: Optional(Array(BoundFlight)),
  upsellTable: Object({
    columns: Object({
      outbound: Optional(Array(String())),
      inbound: Optional(Array(String())),
    }),
    tabs: UpsellTableTabs,
  }),
  fareRules: Record(String(), FareRules),
  officeId: String(),
  commercialFareFamily: Optional(String()),
});
export type TravelPassFlightOffersResponse = Static<typeof TravelPassFlightOffersResponse>;
